module.exports = "/_next/static/images/DashboardExplore@2x-74418018609bdfeb7a3f0e1855c9dec5.png";